import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@/hooks/use-auth';
import { isStaff } from '@/lib/landing';

/**
 * Hides staff-only screens from customers.
 *
 * This is a navigation convenience, not a security control — every admin endpoint
 * enforces its own role check server-side, so a customer who forces the URL still
 * gets nothing back.
 */
export function StaffRoute() {
  const { user } = useAuth();

  if (user && !isStaff(user.role)) {
    // `/dashboard`, not `/` — `/` is the public landing page, which would bounce a signed-in
    // customer straight back here through an extra render.
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
}
